import { createReducer } from 'redux-create-reducer';

import { GET_COUNTRIES } from '../types';

const initialState = [];

const nationalitiesReducer = createReducer(initialState, {
  [GET_COUNTRIES.FULFILLED]: (state, { payload }) => payload.data,
});

export default nationalitiesReducer;


// WEBPACK FOOTER //
// ./src/reducers/countriesReducer.js